import React from 'react';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Main from './Main';

const Home = () => {

    return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
    )
}

export default Home;